var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Ops"},[_c('top-information'),_c('tabs-bar'),_c('tabs-bar',{staticClass:"top",class:_vm.tabsBarVisible}),_c('advatage'),_c('ability'),_c('solutions')],1)}
var staticRenderFns = []

export { render, staticRenderFns }